export const newFieldDefaults = {
  type: "",
  name: "",
  display_name: "",
  sort: null,
  width: null,
  validator: "",
  char_min: null,
  char_limit: null,
  required: false,
  placeholder: "",
  default_value: "",
  help_text: "",
  informs_global: false,
  quick_edit: false,
  universal_quick_edit: false,
  unread_quick_edit: false,
  alpha: false,
  file_ext_whitelist: "",
};

export const fieldTypes = [
  { label: "Please select", value: "" },
  { label: "text", value: "text" },
  { label: "textarea", value: "textarea" },
  { label: "select", value: "select" },
  { label: "radio", value: "radio" },
  { label: "checkbox", value: "checkbox" },
  { label: "file", value: "file" },
];

export const widthOptions = [
  { label: "full", value: 1 },
  { label: "half", value: 2 },
  { label: "third", value: 3 },
];

export const newWidthOptions = [
  { label: "Please select", value: "" },
  ...widthOptions,
];

export const validatorOptions = [
  { label: "none", value: "" },
  { label: "email", value: "email" },
  { label: "alpha", value: "alpha" },
  { label: "numeric", value: "number" },
  { label: "phone", value: "phone" },
  { label: "currency", value: "currency" },
  { label: "date", value: "date" },
];

export function checkCharMin(value, comparison) {
  return (
    value == "" ||
    !comparison ||
    value < comparison ||
    value == comparison ||
    "Must be less than or equal to character limit"
  );
}

export function checkCharLimit(value, comparison) {
  return (
    value == "" ||
    !comparison ||
    value > comparison ||
    value == comparison ||
    "Must be greater than or equal to character minimum"
  );
}

export function noZeros(value) {
  return value == "" || value == null || value > 0 || "Cannot be zero";
}
